import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getNewsletter,
  editNewsletter,
} from "../../store/actions/newsletters_action";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/layout/Spinner";
import AddForm from "../../components/common/AddForm";
import { upload } from "../../shared/upload";
import {
  initialValues,
  inputFields,
} from "../../shared/enums/newsletters_enum";

const EditNewsletter = ({
  editNewsletter,
  getNewsletter,
  match,
  newsletter: { loading, newsletter },
}) => {
  let history = useHistory();
  useEffect(() => {
    getNewsletter(match.params.id);
  }, [match]);
  const [featuredImage, setFeaturedImage] = useState(null);
  const [gallery, setGallery] = useState(null);
  const submitNewsletter = async (values) => {
    if (featuredImage || gallery) {
      const images = await upload(featuredImage, gallery);
      if (images) {
        if (images.featured_image) {
          values.featured_image = images.featured_image;
        }
        if (images.gallery_images) {
          values.gallery = images.gallery_images;
        }
      }
    }
    await editNewsletter(newsletter.id, values);
    history.push(`/newsletters/${newsletter.id}/view`);
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Edit Newsletter"
          mainLinkTitle="Newsletters"
          mainLinkUrl="/newsletters"
          activeLink="Edit"
        />
      </div>
      <div className="container-fluid">
        <div className="col-lg-12">
          <div className="card">
            {!loading ? (
              newsletter && (
                <div>
                  <div className="card-header">
                    <div>
                      <h4 className="card-title">
                        {newsletter.title} - <span>Edit</span>{" "}
                      </h4>
                      <p className="card-title-desc">
                        <Link to="/newsletters" className="btn btn-soft-light">
                          <i className="fa fa-angle-left"></i> Newsletters
                        </Link>
                        <Link
                          to={`/newsletters/${newsletter.id}/view`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-eye"></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <AddForm
                    data={newsletter}
                    edit={true}
                    featuredImage={featuredImage}
                    gallery={gallery}
                    setFeaturedImage={setFeaturedImage}
                    setGallery={setGallery}
                    submitForm={submitNewsletter}
                    inputFields={inputFields}
                    initialValues={initialValues}
                  />
                </div>
              )
            ) : (
              <div className="text-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  alert: state.alert,
  newsletter: state.newsletter,
});

const mapDispatchToProps = { editNewsletter, getNewsletter };

export default connect(mapStateToProps, mapDispatchToProps)(EditNewsletter);
